import { AmountUscContainer, isFinanceableAmountUsd, usCentsToUsd } from '@breezy/shared'
import { useWisetackEnabled, useWisetackMerchantId } from '../providers/CompanyFinancialConfigWrapper'
import { trpc } from './trpc'

export const useLoanPromo = ({ amountUsc }: AmountUscContainer) => {
  const wisetackEnabled = useWisetackEnabled()
  const wisetackMerchantId = useWisetackMerchantId()
  const isFinanceableAmount = isFinanceableAmountUsd(usCentsToUsd(amountUsc))
  const shouldShowLoanPromo = wisetackEnabled && !!wisetackMerchantId && isFinanceableAmount
  // NOTE: Promo is just for promotional purposes, so it won't matter if we're off by less than a penny
  const intAmountUsc = Math.ceil(amountUsc)
  const query = trpc.financing['unauth:financing:get-loan-promo'].useQuery(
    { amountUsc: intAmountUsc, merchantGuid: wisetackMerchantId ?? '' },
    {
      enabled: shouldShowLoanPromo,
    },
  )

  return { query, shouldShowLoanPromo }
}
